import 'react-app-polyfill/stable'
import 'mobx-react/batchingForReactDom'

import React from 'react'
import { render } from 'react-dom'
// import { AppContainer } from 'react-hot-loader'
// import { getTheme } from '_core/themes/getTheme'
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'

// core
import { App } from '_core/components/App'

const init = async () => {
  const config = await import(`${process.env.REACT_APP_PROJECT}/config`)
  const { slots } = await import(`${process.env.REACT_APP_PROJECT}/slots`)
  const { routes } = await import(`${process.env.REACT_APP_PROJECT}/routes`)
  const { menus } = await import(`${process.env.REACT_APP_PROJECT}/menus`)
  const { client, guest } = await import('_core/utils/i18n')

  render(
      <App
        globalContext={{
          config,
          menus,
          slots,
          routes,
          i18n: { client, guest },
        }}
      />,
    document.getElementById('app')
  )

  // TODO: themes pre-render via `http` module

  // const light = await import(`${process.env.REACT_APP_PROJECT}/themes/light`)
  // const dark = await import(`${process.env.REACT_APP_PROJECT}/themes/dark`)

  // document.body.innerHTML =
  //   JSON.stringify(getTheme(light), null, 2) +
  //   '\n\n' +
  //   JSON.stringify(getTheme(light), null, 2)
}

init()

//if (module.hot) {
//  module.hot.accept('_core/components/App', () => {
//    init()
//  })
//}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.unregister()
